import {UserContext} from "@hosttools/frontend";
import type {ComponentType} from "react";
import {useContext} from "react";
import type {RouteComponentProps} from "react-router-dom";
import {Redirect, Route} from "react-router-dom";

import Footer from "./components/Footer";

import ExternalServices from "@/client/components/ExternalServices";

interface PublicRouteProps {
    path: string;
    component: ComponentType<RouteComponentProps>;
    redirect?: boolean;
}

function PublicRoute({component: Component, redirect, ...rest}: PublicRouteProps) {
    const {isAuthenticated} = useContext(UserContext);

    const route = (
        <Route
            {...rest}
            render={props => {
                if (isAuthenticated === true && redirect) {
                    return <Redirect to={{pathname: "/"}} />;
                }
                return (
                    <>
                        <Component {...props} />
                        <Footer />
                        <ExternalServices />
                    </>
                );
            }}
        />
    );

    return route;
}

export default PublicRoute;
